export const CommentRowHeight = 22;
export const MaxCommentRowCount = 2;
export const AvatarHeight = 50;
